import type { AuthMode } from "@/types/api";

/** Тексты отказов входа через SSO по коду `?sso_error=` из callback бэкенда
 *  (`backend/src/wh_helper/sso/router.py`, `sso/linking.py`, `sso/roles.py`). */
export const SSO_ERROR_TEXTS: Record<string, string> = {
  no_access: "Нет доступа к порталу: попросите выдать роль в SSO.",
  not_linked:
    "Вход через SSO прошёл, но учётная запись портала с таким логином не найдена. " +
    "Обратитесь к администратору портала.",
  inactive: "Ваша учётная запись портала отключена. Обратитесь к администратору портала.",
  sub_conflict:
    "Учётная запись портала с этим логином уже связана с другой учётной записью SSO. " +
    "Обратитесь к администратору портала.",
  org:
    "Учётная запись SSO относится к чужой организации — в этот портал с ней не войти. " +
    "Обратитесь к администратору портала.",
  state:
    "Сеанс входа через SSO устарел или был начат в другой вкладке. " +
    "Нажмите «Войти через SSO» ещё раз.",
  idp:
    "Сервер SSO отказал во входе или не ответил. Попробуйте ещё раз; " +
    "если повторяется — обратитесь к администратору портала.",
};

/** Текст отказа по коду. Неизвестный код называется как есть — это рассинхрон
 *  с бэкендом, и прятать его за общим «ошибка входа» нельзя. */
export function ssoErrorText(code: string): string {
  return (
    SSO_ERROR_TEXTS[code] ??
    `Вход через SSO не удался (неизвестный код ошибки «${code}»). Обратитесь к администратору портала.`
  );
}

export const AUTH_MODE_LABELS: Record<AuthMode, string> = {
  sso: "SSO",
  password: "Пароль",
  badge: "Пропуск",
};

/** Подпись режима входа. Неизвестное значение показываем как есть, а не
 *  выдаём за «Пароль»: от режима зависит, как портал ходит в 1С. */
export function authModeLabel(mode: string | undefined): string {
  if (mode && mode in AUTH_MODE_LABELS) return AUTH_MODE_LABELS[mode as AuthMode];
  return `режим «${String(mode)}»`;
}
